// LP のブラウザの側。書き出した HTML の中の島 ([data-island]) だけを動かす (hydrate)。
// 島の中身と props は書き出し (island.tsx) が入れている。それ以外の部分は静的な HTML のまま。
import type { ComponentType } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { type IslandId, islandWrap } from './islands';
import './styles/lp.css';

type Loader = () => Promise<ComponentType<object>>;
const c = <T,>(p: Promise<T>, pick: (m: T) => unknown) =>
  p.then((m) => pick(m) as ComponentType<object>);

const LOADERS: Record<IslandId, Loader> = {
  'app/(marketing)/_components/site-header#SiteHeader': () =>
    c(import('@/app/(marketing)/_components/site-header'), (m) => m.SiteHeader),
  'app/(marketing)/_components/floating-cta#FloatingCta': () =>
    c(import('@/app/(marketing)/_components/floating-cta'), (m) => m.FloatingCta),
  'app/(marketing)/_components/template-promo#TemplatePromo': () =>
    c(import('@/app/(marketing)/_components/template-promo'), (m) => m.TemplatePromo),
  'components/analytics/doc-request-link#DocRequestLink': () =>
    c(import('@/components/analytics/doc-request-link'), (m) => m.DocRequestLink),
  'app/(marketing)/contact/contact-form#ContactForm': () =>
    c(import('@/app/(marketing)/contact/contact-form'), (m) => m.ContactForm),
  'app/(marketing)/blog/_components/blog-filter#BlogFilter': () =>
    c(import('@/app/(marketing)/blog/_components/blog-filter'), (m) => m.BlogFilter),
  'app/(marketing)/templates/_components/templates-filter#TemplatesFilter': () =>
    c(import('@/app/(marketing)/templates/_components/templates-filter'), (m) => m.TemplatesFilter),
  'lp/app-shell#AppShell': () => c(import('./app-shell'), (m) => m.AppShell),
};

async function hydrate(el: HTMLElement): Promise<void> {
  const id = el.dataset.island as IslandId;
  const load = LOADERS[id];
  if (!load) return;
  const C = await load();
  const props = JSON.parse(el.dataset.p ?? '{}') as object;
  const Wrap = islandWrap(id);
  const node = Wrap ? (
    <Wrap>
      <C {...props} />
    </Wrap>
  ) : (
    <C {...props} />
  );
  hydrateRoot(el, node, { identifierPrefix: `${el.dataset.k}-` });
}

for (const el of document.querySelectorAll<HTMLElement>('[data-island]')) {
  hydrate(el).catch((e) => console.error('[lp] hydrate failed', el.dataset.island, e));
}
